<template>
<div class="page page-zuji" :style="showDel ? 'padding-bottom:2rem ;' : 'padding-bottom:0.4rem ;' ">
    <div class="zuji-top">
        <div class="guanli" @click="clickGuanli">{{ showDel ? '完成' : '管理' }}</div>
        <van-tabs v-model="active" line-width="0.4rem" class="custom-tabs unflex" @click="onClickTab">
            <van-tab title="商品" :name="0"></van-tab>
            <van-tab title="定制" :name="1"></van-tab>
            <van-tab title="匠人" :name="2"></van-tab>
            <van-tab title="项目" :name="5"></van-tab>
        </van-tabs>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list-wrap" v-if="active == 0">
                <div class="list-day" v-for="(item,index) in dataList" :key="index">
                    <div class="day-name">{{ item.day }}</div>
                    <div class="days-sec">
                        <div class="day-item" v-for="(goods,index) in item.list" :key="index" @click="clickItem(goods,item.day)">
                            <div class="item-l" v-if="showDel">
                                <img :src="goods.isSelected ? publicPath+'statics/images/active.png': publicPath+'statics/images/inactive.png' " alt="" class="select-icon">
                            </div>
                            <div class="item-r">
                                <img :src="goods.thumb ? imageUrl+goods.thumb : $publicData.intangibleDefault" alt="" class="thumb">
                                <div class="item-r-r goods">
                                    <div class="title slh_s">{{ goods.title }}</div>
                                    <div class="price">价格：¥ {{ goods.price }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-wrap" v-if="active == 1">
                <div class="list-day" v-for="(item,index) in dataList" :key="index">
                    <div class="day-name">{{ item.day }}</div>
                    <div class="days-sec">
                        <div class="day-item" v-for="(dingzhi,index) in item.list" :key="index" @click="clickItem(dingzhi,item.day)">
                            <div class="item-l" v-if="showDel">
                                <img :src="dingzhi.isSelected ? publicPath+'statics/images/active.png' : publicPath+'statics/images/inactive.png' " alt="" class="select-icon">
                            </div>
                            <div class="item-r">
                                <img :src="dingzhi.thumb ? imageUrl+dingzhi.thumb : $publicData.intangibleDefault" alt="" class="thumb">
                                <div class="item-r-r xiangmu">
                                    <div class="title slh_s">{{ dingzhi.title }}</div>
                                    <van-progress :percentage="dingzhi.percentage" :pivot-text="dingzhi.hadMadeCount+'件'" color="linear-gradient(-90deg, #DF3434, #FF5F34)" />
                                    <span class="desc" v-if="dingzhi.end_at">{{ dingzhi.timeLeft ? '剩余时长：' : '截止日期：' }} {{ dingzhi.timeLeft ? dingzhi.timeLeft :dingzhi.end_at }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-wrap" v-if="active == 2">
                <div class="list-day" v-for="(item,index) in dataList" :key="index">
                    <div class="day-name">{{ item.day }}</div>
                    <div class="days-sec">
                        <div class="day-item" v-for="(tradesman,index) in item.list" :key="index" @click="clickItem(tradesman,item.day)">
                            <div class="item-l" v-if="showDel">
                                <img :src="tradesman.isSelected ? publicPath+'statics/images/active.png' : publicPath+'statics/images/inactive.png'" alt="" class="select-icon">
                            </div>
                            <div class="item-r">
                                <img :src="tradesman.thumb ? imageUrl+tradesman.thumb : $publicData.defaultTouxiang" alt="" class="tradesman-thumb">
                                <div class="item-r-r xiangmu">
                                    <div class="title slh_s">{{ tradesman.title }}</div>
                                    <div class="level slh_s" v-if="tradesman.auth_company">{{ tradesman.auth_company }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-wrap" v-if="active == 5">
                <div class="list-day" v-for="(item,index) in dataList" :key="index">
                    <div class="day-name">{{ item.day }}</div>
                    <div class="days-sec">
                        <div class="day-item" v-for="(mapItem,index) in item.list" :key="index" @click="clickItem(mapItem,item.day)">
                            <div class="item-l" v-if="showDel">
                                <img :src="mapItem.isSelected ? publicPath+'statics/images/active.png' : publicPath+'statics/images/inactive.png'" alt="" class="select-icon">
                            </div>
                            <div class="item-r">
                                <img :src="mapItem.thumb ? imageUrl+mapItem.thumb : $publicData.intangibleDefault" alt="" class="thumb">
                                <div class="item-r-r xiangmu">
                                    <div class="title slh_s">{{ mapItem.title }}</div>
                                    <div class="address">
                                        <span class="">地址：</span>
										<span v-if="mapItem.area_province">{{ mapItem.area_province }}</span>
										<span v-if="mapItem.area_city">{{ mapItem.area_city }}</span>
										<span v-if="mapItem.area_city2">{{ mapItem.area_city2 }}</span>
                                    </div>
                                    <div class="desc">
                                        <span class="cate">{{ mapItem.level }}</span>
                                        <span class="juli">距离约{{ mapItem.distance.toFixed(2) }}千米</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
    <div class="bottom-wrap" v-if="showDel">
        <div class="bottom">
            <div class="bottom-l">
                <van-checkbox v-model="checkedAll" @change="changeAll">
                    全选
                    <template #icon="props">
                        <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                    </template>
                </van-checkbox>
            </div>
            <div class="del-btn" @click="delFun">删除</div>
        </div>
    </div>
</div>
</template>

<script>

import Vue from 'vue';
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
            token: null,
            active: 0, // 0商品1定制2匠人5项目
            showDel: false,
            checkedAll: false,
            page: 1,
            size: 10,
            loading: true,
            finished: false,
            defaultList: [], // 未组前的数据(做中转用)
            dataList: [], // 数据表
            riqiList: [], // 日期列表
            refreshing: false,
			publicPath: process.env.BASE_URL,
			activeIcon: process.env.BASE_URL+"statics/images/active.png",
			inactiveIcon: process.env.BASE_URL+"statics/images/inactive.png",
            imageUrl: this.$publicData.uploadImage
        }
    },
	watch: {
		'$route': function(to,from){
			// console.log('to',to)
			// console.log('from',from)
			this.showDel = false;
			if(from.name == 'my'){
				this.loading = true;
				this.page= 1;
				this.defaultList = [];
				this.dataList = [];
				this.riqiList = [];
				this.getData();
			}
		}
	},
    created() {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '足迹'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // this.getData()
                responseCallback({})
            })
        } else {
            this.token = this.$store.getters.token
            this.getData()
        }
    },
    mounted() {
        // this.token = this.$store.getters.token;
        // this.getData();
    },
    methods: {
        onRefresh() {
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1;
            this.defaultList = [];
            this.dataList = [];
            this.riqiList = [];
            this.getData();
        },
        getData() {
            let params = {
                token: this.token,
                page: this.page,
                size: this.size,
                sorce: this.active
            }
            if (this.active == 5) {
                params.lng = localStorage.getItem('lng') ? localStorage.getItem('lng') : localStorage.getItem('lngDefault');
                params.lat = localStorage.getItem('lat') ? localStorage.getItem('lat') : localStorage.getItem('latDefault');
            }
            this.$api.my.lookrecord(params).then(res => {
                if (res.code == 200) {
                    let list = res.result;
                    for (let i in list) {
                        list[i].isSelected = false;
                        let ymd = list[i].create_at.split(' ')[0];
                        let ymdz = ymd.split('-')
                        list[i].lookday = ymdz[0] + '年' + ymdz[1] + '月' + ymdz[2] + '日';
                        // 当是定制时,需要计算 已定制数 = 真实定制 + 假数据
                        if (this.active == 1) {
                            let hadMadeCount = null
                            let leftMadeCount = null
                            let percentage = null
                            let totalCount = list[i].accept_order_count ? list[i].accept_order_count : 0
                            let realCount = list[i].order_count ? list[i].order_count : 0
                            let falseCount = list[i].false_data ? list[i].false_data : 0
                            if (parseInt(realCount) + parseInt(falseCount) <= totalCount) {
                                hadMadeCount = parseInt(realCount) + parseInt(falseCount)
                                leftMadeCount = totalCount - realCount - falseCount
                            } else {
                                hadMadeCount = totalCount
                                leftMadeCount = 0
                            }
                            if (totalCount > 0) {
                                percentage = Math.floor((hadMadeCount / totalCount) * 100)
                            } else {
                                percentage = 0
                            }
                            list[i].leftMadeCount = leftMadeCount
                            list[i].hadMadeCount = hadMadeCount
                            list[i].percentage = percentage
                            // 剩余时长 以'天'计
                            if (list[i].end_at) {
                                let endTimestamp = this.getTimes(list[i].end_at)
                                let currentTimestamp = Date.parse(new Date())
                                // console.log('结束时间戳',endTimestamp)
                                // console.log('当天时间戳',currentTimestamp)
                                list[i].timeLeft = this.$publicData.intervalTime(currentTimestamp, endTimestamp)
                            } else {
                                list[i].timeLeft = false
                            }
                        }
                        this.defaultList.push(list[i])
                    };
                    // 组装
                    this.formatData()
                    // 分页
                    this.page++;
                    this.loading = false;
                    this.refreshing = false;
                    if (list.length == 0) {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
            })
        },
        // 点击
        onClickTab() {
            this.page = 1;
            this.loading = true;
            this.finished = false;
            this.dataList = [];
            this.defaultList = [];
            this.checkedAll = false;
            this.getData()
        },
        // 点击完成&管理
        clickGuanli() {
            this.showDel = !this.showDel;
        },
        // 点击各项
        clickItem(item, day) {
            let list = this.dataList;
            if (this.showDel) {
                // 点选删除操作
                for (let i in list) {
                    if (list[i].day == day) {
                        let itemList = list[i].list;
                        for (let j in itemList) {
                            if (itemList[j].id == item.id) {
                                itemList[j].isSelected = !item.isSelected
                                break;
                            }
                        }
                        break;
                    }
                }
                this.dataList = list;
                // console.log('点选删除item',item)
                // console.log('总列表',this.dataList)
            } else {
                // 跳转操作
                // console.log('跳转操作item',item)
                if (this.active == 0) {
                    // 商品
                    this.routeLink('/shop/detail', {
                        goodsId: item.content_id
                    })
                } else if (this.active == 1) {
                    // 定制
                    this.routeLink('/dingzhi/detail', {
                        id: item.content_id
                    })
                } else if (this.active == 2) {
                    // 匠人 art/detail?tradesmanId=28&register_status=1
                    this.routeLink('/art/detail', {
                        tradesmanId: item.content_id
                    })
                } else if (this.active == 5) {
                    // 项目点
                    this.routeLink('/item/detail', {
                        id: item.content_id
                    })
                }
            }
        },
        // 全选
        changeAll() {
            // console.log('全选',this.checkedAll)
            let list = this.dataList;
            for (let i in list) {
                let item = list[i].list;
                for (let j in item) {
                    item[j].isSelected = this.checkedAll
                }
            }
            this.dataList = list;
        },
        // 删除
        delFun() {
            let arr = [];
            let list = this.dataList;
            for (let i in list) {
                let item = list[i].list;
                for (let j in item) {
                    if (item[j].isSelected) {
                        arr.push(item[j].id)
                    }
                }
            }
            if (arr.length == 0) {
                this.$toast('请选择要删除的内容');
                return;
            } else {
                let params = {
                    token: this.token,
                    ids: arr
                }
                // console.log('arr',arr)
                this.$api.my.dellookrecord(params).then(res => {
                    if (res.code == 200) {
                        this.$toast(res.message);
                        // 全部删除
                        if (this.checkedAll) {
                            this.page = 1;
                            this.loading = true;
                            this.finished = false;
                            this.dataList = [];
                            this.getData();
                        } else {
                            // 非全部
                            this.updateList(arr)
                        }
                    }
                })
            }
        },
        // 更新列表
        updateList(arr) {
            let list = this.defaultList;
            for (let i in list) {
                for (let j in arr) {
                    if (list[i].id == arr[j]) {
                        list.splice(i, 1)
                    }
                }
            }
            this.defaultList = list;
            this.formatData();
        },
        // 重组 规划到天
        formatData() {
            let zuArr = [];
            this.riqiList = [];
            let list = this.defaultList;
            // console.log('defaultList',this.defaultList)
            for (let i in list) {
                let arr = [];
                arr.push(list[i]);
                // 判断那天是否存在
                if (this.riqiList.indexOf(list[i].lookday) == -1) {
                    this.riqiList.push(list[i].lookday);
                    zuArr.push({
                        day: list[i].lookday,
                        list: arr
                    })
                } else {
                    for (let j in zuArr) {
                        if (list[i].lookday == zuArr[j].day) {
                            zuArr[j].list.push(list[i]);
                            break;
                        }
                    }
                }
            }
            this.dataList = zuArr;
            // console.log('this.dataList',zuArr)
        },
        // 路由跳转
        routeLink(url, obj) {
            this.$router.push({
                path: url,
                query: obj
            })
        },
		// 兼容ios的 new Date传参, 获取时间戳; str 格式 '2020-07-15'
		getTimes(strdate){
			let arr = strdate.split(/[- : \/]/);
			let date = new Date(arr[0], arr[1] - 1, arr[2],24,0,0);
			return date;
		},
    },
}
</script>
